const FileType = {
  IMAGE: 1,
  VIDEO: 2,
  DOC: {
    PDF: 3,
    WORD: 4,
    EXCELL: 5,
    CSV: 6,
    IPA: 8,
    APK: 9,
    NUMBERS: 10,
  },
  AUDIO: 7,
}

const getFileExtension = fileName => {
  if (!fileName) return 0
  const fileExtension = fileName.replace(/^.*\./, '')
  return fileExtension.toLowerCase()
}

const getFileType = url => {
  const ext = getFileExtension(url)
  const imagesExtension = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'ico', 'svg']
  const videoExtensions = [
    'mp4',
    'mov',
    'wmv',
    'avi',
    'avchd',
    'flv',
    'f4v',
    'swf',
    'mkv',
    'mpeg-2',
  ]
  const docExtensions = [
    'pdf',
    'xlsx',
    'xls',
    'csv',
    'doc',
    'docx',
    'apk',
    'ipa',
    'numbers',
  ]
  const audioExtensions = ['mp3', 'wav', 'ogg']
  if (imagesExtension.includes(ext)) {
    return FileType.IMAGE
  }
  if (videoExtensions.includes(ext)) {
    return FileType.VIDEO
  }
  if (docExtensions.includes(ext)) {
    if (ext === 'pdf') return FileType.DOC.PDF
    if (ext === 'xlsx' || ext === 'xls') return FileType.DOC.EXCELL
    if (ext === 'csv') return FileType.DOC.CSV
    if (ext === 'doc' || ext === 'docx') return FileType.DOC.WORD
    if (ext === 'apk') return FileType.DOC.APK
    if (ext === 'ipa') return FileType.DOC.IPA
    if (ext === 'numbers') return FileType.DOC.NUMBERS
    return 0
  }
  if (audioExtensions.includes(ext)) {
    return FileType.AUDIO // You need to define FileType.AUDIO
  }
  return 0
}

const isAudio = urlOrObj => {
  if (typeof urlOrObj !== 'string' && urlOrObj) {
    if (urlOrObj.type && urlOrObj.type.startsWith('audio/')) return true
    if (urlOrObj.name) return getFileType(urlOrObj.name) === FileType.AUDIO
  }
  return getFileType(urlOrObj) === FileType.AUDIO
}

const isImage = urlOrObj => {
  if (typeof urlOrObj !== 'string' && urlOrObj) {
    // File object case
    if (urlOrObj.type && urlOrObj.type.startsWith('image/')) return true
    if (urlOrObj.name) return getFileType(urlOrObj.name) === FileType.IMAGE
  }
  const url = urlOrObj
  return getFileType(url) === FileType.IMAGE || (url && url.includes('data:image'))
}

const isVideo = urlOrObj => {
  if (typeof urlOrObj !== 'string' && urlOrObj) {
    if (urlOrObj.type && urlOrObj.type.startsWith('video/')) return true
    if (urlOrObj.name) return getFileType(urlOrObj.name) === FileType.VIDEO
  }
  return getFileType(urlOrObj) === FileType.VIDEO
}

const isPdf = urlOrObj => {
  if (typeof urlOrObj !== 'string' && urlOrObj?.name) return getFileType(urlOrObj.name) === FileType.DOC.PDF
  return getFileType(urlOrObj) === FileType.DOC.PDF
}

const isWord = urlOrObj => {
  if (typeof urlOrObj !== 'string' && urlOrObj?.name) return getFileType(urlOrObj.name) === FileType.DOC.WORD
  return getFileType(urlOrObj) === FileType.DOC.WORD
}

const isExcel = urlOrObj => {
  if (typeof urlOrObj !== 'string' && urlOrObj?.name) return getFileType(urlOrObj.name) === FileType.DOC.EXCELL
  return getFileType(urlOrObj) === FileType.DOC.EXCELL
}

const isCsv = urlOrObj => {
  if (typeof urlOrObj !== 'string' && urlOrObj?.name) return getFileType(urlOrObj.name) === FileType.DOC.CSV
  return getFileType(urlOrObj) === FileType.DOC.CSV
}

const isDoc = urlOrObj => {
  const fileType = typeof urlOrObj !== 'string' && urlOrObj?.name ? getFileType(urlOrObj.name) : getFileType(urlOrObj)
  return (
    fileType === FileType.DOC.PDF
    || fileType === FileType.DOC.WORD
    || fileType === FileType.DOC.EXCELL
    || fileType === FileType.DOC.CSV
    || fileType === FileType.DOC.IPA
    || fileType === FileType.DOC.APK
    || fileType === FileType.DOC.NUMBERS
  )
}

function defineFileType(file) {
  const mediaExtensions = {
    image: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff'],
    video: ['.mp4', '.mov', '.avi', '.wmv', '.mkv', '.webm'],
    audio: ['.mp3', '.wav', '.ogg', '.flac', '.aac'],
  }

  if (typeof file === 'string') {
    const extension = file.split('.').pop().toLowerCase()

    return Object.keys(mediaExtensions).some(category => mediaExtensions[category].includes(extension)) ? 'media' : 'file'
  }
  if (file instanceof File) {
    // Check MIME type
    const mimeType = file.type
    if (mimeType.startsWith('image/')) {
      return 'media'
    }
    if (mimeType.startsWith('video/')) {
      return 'media'
    }
    if (mimeType.startsWith('audio/')) {
      return 'media'
    }
  }

  // Default to "file" if type cannot be determined
  return 'file'
}

function getFileExtDisplay(str) {
  const ext = getFileExtension(str)

  if (typeof ext !== 'string') return 'N/A'
  return ext.slice(0, 3)
}

// Example usage
// const filePath = "image.jpg";
// const fileObject = new File(["file content"], "audio.mp3", {
//   type: "audio/mpeg",
// });

// const fileTypePath = defineFileType(filePath);
// const fileTypeObject = defineFileType(fileObject);

// console.log(`File path type: ${fileTypePath}`); // Output: media
// console.log(`File object type: ${fileTypeObject}`); // Output: media

export {
  isImage,
  isVideo,
  isDoc,
  isPdf,
  isWord,
  isExcel,
  isCsv,
  isAudio,
  defineFileType,
  getFileExtDisplay,
}
